export const TRANSLATIONS_FR = {
  components: {
    header: { text: "Vous avez des questions?" },
    footer: {
      firstRow: "Cornèr Banque SA,",
      secondRow: "Via Canova 16, 6901 Lugano - Suisse",
    },
  },
  screens: {
    common: {
      mr: "Monsieur",
      mrs: "Madame",
      haveQuestions: "Vous avez des questions?",
      back: "Retour",
      continue: "Poursuivre",
      change: "Change",
      yes: "Oui",
      no: "Non",
      none: "Aucun",
      other: "Autre",
      confirm: "Confirmer",
      remove: "Remove",
      optional: "optional",
      skipStep: "Ignorer cette étape et passer à la suivante",
      backHome: "Aller au site",
      cancelOnboarding: "Annuler l’onboarding",
      search: "Search",
      disclaimer: "Disclaimer",
      impressum: "Impressum",
      copyrightAddr: "Tödistrasse 27, CH-8002, Zurich - Suisse",
      errorDate: "Age accepté de 18 à 65 ans",
      underageBo: "L'ayant droit économique doit être majeur.",
      chZipRequired: "Veuillez saisir un code postal valide.",
      readOnlyMessage:
        "Toute information erronée qui ne peut être modifiée sur cette page doit être communiquée à Cornèrcard.",
      disclaimerLink_prep:
        "https://www.prep.corner.ch/fr/disclaimer/onboarding-corner3/index.html",
      disclaimerLink_prod:
        "https://www.corner.ch/fr/disclaimer/onboarding-corner3/index.html",
    },
    personalData: {
      pageTitle: "C’est parti!",
      pageSubtitle:
        "Ouvrez votre compte de prévoyance Cornèr3 en quelques minutes seulement.",
      firstName: "Prénom",
      lastName: "Nom",
      dataInfo:
        "Saisissez les données précisément telles qu’elles apparaissent sur votre pièce d’identité.",
      email: "Adresse e-mail",
      phoneNr: "Numéro de téléphone",
      emailRequired: "Veuillez saisir une adresse e-mail valide.",
      phoneRequired:
        "Format composé uniquement de chiffres, par ex.: 7812234567",
      gtcAgree:
        "Je confirme d’avoir lu la <Disclaimer>clause de non-responsabilité</Disclaimer> et de l’accepter. En outre, je confirme que  je remplis les <Requirements>conditions requises pour la souscription du produit par voie numérique.</Requirements>",
      requirementsModal: {
        title: "Conditions requises",
        subTitle:
          "La souscription numérique du produit est réservée aux personnes qui:",
        data1:
          "sont assujetti(e)s à l’impôt de manière illimitée en Suisse et perçoivent un revenu soumis à l’AVS/AI tiré d’une activité lucrative, salariée ou indépendante;",
        data2:
          "connaissent et acceptent les risques liés à l’utilisation des systèmes informatiques et/ou des canaux numériques, tels que les sites Internet, les plateformes en ligne ou les applications pour smartphones mis à disposition par la Fondation de Prévoyance Cornèr Troisième Pilier, la Banque et/ou des tiers.",
        understood: "J’ai compris",
      },
    },
    personalDataAdditional: {
      pageTitle: "Quelques informations vous concernant",
      birthDate: "Date de naissance",
      birthCountry: "Pays de naissance",
      nationality: "Nationalité",
      maritalStatus: "État civil",
      maritalStatusList: {
        married: "Marié(e) ou autres unions",
        divorced: "Divorcé(e)",
        widowed: "Veuf/veuve",
        unmarried: "Célibataire",
        separated: "Séparé(e)",
      },
      avsNumber: "Votre numéro AVS",
      avs: "Votre numéro AVS",
      avsInfo: "<AvsInfo>Où se trouve mon numéro AVS?</AvsInfo>",
      avsModal: {
        title: "Où se trouve mon numéro AVS?",
        description:
          "Si vous habitez ou si vous travaillez en Suisse, vous trouverez votre numéro AVS tout simplement au dos de votre carte de caisse-maladie; vous pouvez aussi l’obtenir auprès de la caisse de compensation de votre canton de résidence.",
        understood: "J’ai compris",
      },
    },
    address: {
      pageTitle: "Quel est votre lieu de résidence?",
      pageSubTitle:
        "Les codes d’accès aux outils numériques Cornèronline et iCornèr App vous seront envoyés à l’adresse indiquée.",
      country: "Pays",
      city: "Localité",
      zipCode: "NPA",
      street: "Rue",
      streetNumber: "Numéro",
    },
    employmentsDetail: {
      pageTitle: "Quelle est votre situation professionnelle?",
      employed: "Employé(e)",
      freelancer: "Indépendant(e)",
      qualification: "Profession",
      pensionFund: "Vous êtes affilié(e) à une caisse de pension (2e pilier)?",
    },
    informationRecap: {
      pageTitle: "Vérifiez vos données!",
      pageSubtitle:
        "Vérifiez à nouveau les informations que vous avez saisies avant de procéder à la signature du contrat.",
      cta: "Confirmer",
      personalData: "Informations personnelles et de contact",
      employmentsDetail: "Informations professionnelles",
      terms:
        "Je confirme que j’ai pris connaissance des <Terms>conditions du produit</Terms>, et que j’accepte les <GeneralTerms>conditions générales de la Banque.</GeneralTerms>",
      termsLink_prep:
        "https://www.prep.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/CORNER3/374a_FR_Fondazione-di-Previdenza-Corner-Terzo-Pilastro-Regolamento.pdf",
      termsLink_prod:
        "https://www.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/CORNER3/374a_FR_Fondazione-di-Previdenza-Corner-Terzo-Pilastro-Regolamento.pdf",
      generalTermsLink_prep:
        "https://www.prep.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/1020_FR_Condizioni-contrattuali.pdf",
      generalTermsLink_prod:
        "https://www.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/1020_FR_Condizioni-contrattuali.pdf",
      dataChanges:
        "Au cas où les informations fournies seraient amenées à être modifiées au fil du temps, vous êtes tenu(e) d’en informer immédiatement la Banque par écrit.",
      gender: "Genre:",
      firstName: "Prénom:",
      lastName: "Nom:",
      email: "Adresse e-mail:",
      phoneNr: "Numéro de téléphone:",
      birthDate: "Date de naissance:",
      birthCountry: "Pays de naissance:",
      nationality: "Nationalité:",
      maritalStatus: "État civil:",
      city: "Localité:",
      zipCode: "NAP:",
      street: "Localité:",
      streetNumber: "Rue:",
      avs: "Votre numéro AVS:",
      currentPosition: "Situation professionnelle:",
      qualification: "Profession:",
      pensionFund: "Vous êtes affilié(e) à une caisse de pension (2e pilier)?",
      infoModal: {
        title: "INFORMAZIONI",
        description:
          "Carica o funzione pubblica dirigenziale, attuale o precedente ricporta, all'estero o in Svizzera, a livello nazionale o internazionale. <br/>Per esempio: membro dei poteri esecutivo, legislativo o giudiziario a livello nazionale come parlamentare, capo di stato, alto funzionario dell'amministrazione, dell'esercito o di partito, membri del CdA o della direzione di imprese statali d'importanza nazionale, dirigenti di organizzazioni intergovernative o federazioni sportive internazionali, persone fisiche legate per motivi famigliari, personali o d'affari ad una persona politicamente esposta, ecc.",
        understood: "Ho capito",
      },
      disclaimerModal: {
        title: "DISCLAIMER",
        description:
          "Carica o funzione pubblica dirigenziale, attuale o precedente ricporta, all'estero o in Svizzera, a livello nazionale o internazionale. <br/>Per esempio: membro dei poteri esecutivo, legislativo o giudiziario a livello nazionale come parlamentare, capo di stato, alto funzionario dell'amministrazione, dell'esercito o di partito, membri del CdA o della direzione di imprese statali d'importanza nazionale, dirigenti di organizzazioni intergovernative o federazioni sportive internazionali, persone fisiche legate per motivi famigliari, personali o d'affari ad una persona politicamente esposta, ecc.",
        understood: "Ho capito",
      },
    },
    contractView: {
      pageTitle: "Préparez-vous à la signature digitale!",
      pageSubtitle:
        "Avant de procéder à la signature digitale, téléchargez votre contrat. Toutefois, vous pourrez le visualiser entièremente lors du processus d'identification vidéo.",
      downloadBtn: "Téléchargez votre contrat",
      btnNext: "Poursuivre",
    },
    videoId: {
      pageTitle: "Signez le contrat en ligne",
      pageSubtitle:
        "Préparez votre caméra et tenez une pièce d’identité à portée de main.",
      mobileSubtitle:
        "Téléchargez l’application d’identification vidéo et suivez les instructions.<br/><br/>Votre code d’identification est le suivant:<br/> <b><TICKET></b>",
      singBtn: "Signez maintenant",
      asset:
        "La signature électronique s’effectue par identification vidéo par notre partenaire Intrum, via un smartphone, une tablette ou un ordinateur.",
    },
    videoIdUnavailable: {
      pageTitle: "Oups! <br/> Aucun opérateur n’est actuellement disponible",
      pageSubtitle:
        "Malheureusement, nous ne pouvons pas confirmer votre identité car aucun opérateur n’est actuellement disponible. </br>Néanmoins, nous venons de vous adresser un <b>e-mail avec les horaires et le lien</b> pour que vous puissiez reprendre votre identification vidéo à un moment ultérieur.<br/><br/>Nous vous remercions de votre compréhension!",
      backBtn: "Fermer",
    },
    successVideoId: {
      pageTitle: "Parfait!",
      pageSubtitle:
        "Votre identité a été confirmée.<br/> Nous vous contacterons dans les prochains jours.",
      backBtn: "Aller au site",
    },
    contract: {
      pageTitle: "Votre contrat est prêt à être signé",
      pageSubtitle:
        "Imprimez votre contrat et suivez les instructions qui figurent sur sa page de couverture. Veuillez nous envoyer ensuite par courrier postal le contrat signé ainsi que les documents demandés.",
      download: "Téléchargez votre contrat",
      print: "Imprimez votre contrat",
    },
    otpResume: {
      title: "Confirmez votre identité",
      subtitle:
        "Veuillez saisir le code à six chiffres que nous vous avons transmis par SMS.",
      noSmsReveiced: "Vous n’avez pas reçu le code? Aucun problème.",
      newSmsRequest: "<0>Demander un nouveau code<0>",
      otpExpired: "Your otp has expired: ask for a new one",
      otpInvalid: "Provided OTP is invalid",
      btnNext: "Poursuivre",
    },
    errors: {
      genericError: {
        title: "Une erreur est survenue",
        subtitle:
          "Oups, quelque chose s’est mal passé.<br/><br/>Veuillez réessayer.<br><br>",
        retry: "Essayer à nouveau",
      },
      failureVideoId: {
        title: "Oups! <br/>Nous avons rencontré un problème!",
        subtitle:
          "Malheureusement, nous n’avons pas pu confirmer votre identité. <br/>Merci d'imprimer le contrat que vous avez téléchargé précédemment, de le signer et de l'envoyer à:<br/><br/><b>Fondation de Prévoyance Cornèr Troisième Pilier<br/>c/o Cornèr Banque SA<br/>Via Canova 16<br/>6901 Lugano<br/>Suisse</b>",
      },
      underageNotAllowed: {
        title: "Il n’est pas possible de traiter votre requête",
        subtitle:
          "Ce produit n’est actuellement disponible que pour les personnes majeures.",
      },
      chResidenceRequired: {
        title: "Il n’est pas possible de traiter votre requête",
        subtitle: "Ce produit n’est actuellement disponible qu'en Suisse.",
      },
      taxResidenceMustBeCH: {
        title: "Il n’est pas possible de traiter votre requête",
        subtitle: "Ce produit n’est actuellement disponible qu'en Suisse.",
      },
      exsclusiveOwnershipRequired: {
        title: "Il n’est pas possible de traiter votre requête",
        subtitle:
          "Pour souscrire à ce produit, vous devez être l’unique ayant droit économique des fonds.",
      },
      usNotAllowed: {
        title: "Il n’est pas possible de traiter votre requête",
        subtitle:
          "Ce produit n'est pas disponible pour les personnes correspondant à la définition de «US Person»",
      },
      missingData: {
        title: "Il n’est pas possible de traiter votre requête",
        subtitle:
          "Pour le traitement de votre requête, il y a malheureusement encore quelques données manquantes.<br/><br/>",
      },
    },
  },
  errors: {
    input: {
      invalidPattern: "Format incorrect",
      minLength: "Au moins {{min}} caractères nécessaires",
      maxLength: "Un maximum de {{max}} caractères est autorisé",
      minPhoneLength:
        "Le numéro de téléphone doit contenir au moins {{min}} chiffres.",
      required: "Champ obligatoire",
      mismatch: "{{fieldName}} ne correspond pas",
      leadingZeroNotAllowed: "Le premier chiffre ne peut pas être 0",
    },
  },
  days: [
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
    "Dimanche",
  ],
  captchaDisclaimer:
    "Ce site est protégé par reCAPTCHA et les <0>règles de confidentialité</0><br/> ainsi que les <1>conditions d'utilisation</1> de Google s'appliquent.",
  captchaTooLow: {
    title: "La vérification du Captcha a échoué",
    description: "Veuillez réessayer",
  },
};
